// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__991Jj","inner":"Form_inner__o5-nx","range":"Form_range__1YTsN","name":"Form_name__37RU0","actions":"Form_actions__3fJtT"};